"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Twitter;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import React from 'react';
// export default function Twitter(props) {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={100} height={100} {...props}>
//       <title>Twitter</title>
//       <g id="Social_media" data-name="Social media">
//         <path d="M79.791,34.724c.047.666.047,1.333.047,2,0,20.32-15.466,43.734-43.734,43.734a43.436,43.436,0,0,1-23.6-6.9,31.945,31.945,0,0,0,3.712.19A30.788,30.788,0,0,0,35.3,67.18,15.4,15.4,0,0,1,20.923,56.52a19.48,19.48,0,0,0,2.9.238,16.257,16.257,0,0,0,4.045-.524A15.373,15.373,0,0,1,15.545,41.149v-.191a15.484,15.484,0,0,0,6.948,1.951,15.4,15.4,0,0,1-4.759-20.558,43.694,43.694,0,0,0,31.7,16.085,17.347,17.347,0,0,1-.381-3.522A15.386,15.386,0,0,1,75.65,24.4a30.256,30.256,0,0,0,9.756-3.712,15.323,15.323,0,0,1-6.758,8.471A30.832,30.832,0,0,0,87.5,26.777a33.057,33.057,0,0,1-7.709,7.947Z" />
//       </g>
//     </svg>
//   );
// }
function Twitter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".twitter0{fill:#FFFFFF;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "twitter0",
    d: "M8,17.5c6,0,9.3-5,9.3-9.3c0-0.1,0-0.3,0-0.4C18,7.3,18.5,6.7,19,6c-0.6,0.3-1.2,0.4-1.9,0.5 c0.7-0.4,1.2-1,1.4-1.8c-0.6,0.4-1.3,0.7-2.1,0.8c-0.6-0.6-1.5-1-2.4-1c-1.8,0-3.3,1.5-3.3,3.3c0,0.3,0,0.5,0.1,0.7 C8.1,8.4,5.7,7.1,4.1,5.1c-0.3,0.5-0.5,1-0.5,1.6c0,1.1,0.6,2.1,1.5,2.7c-0.5,0-1-0.2-1.5-0.4c0,0,0,0,0,0c0,1.6,1.1,2.9,2.6,3.2 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6-0.1c0.4,1.3,1.6,2.3,3,2.3C6.7,15.5,5.3,16,3.8,16c-0.3,0-0.5,0-0.8,0 C4.5,16.9,6.2,17.5,8,17.5"
  }));
}